import Cos from './index';
import { getUploadSignApi } from '@/api/common.js';
import config from '@/config';

const { cosAppId } = config;
Cos.initConfig({
  getTokenFunc: async () => {
    const res = await getUploadSignApi({
      app_id: cosAppId,
      credentials: 1,
    });
    const { sessionToken, tmpSecretId, tmpSecretKey } = res?.data?.credentials || {};
    const {
      cdn_url: cdnUrl,
      key,
      startTime,
      expiredTime,
      Region: region,
      Bucket: bucket,
    } = res?.data || {};
    return {
      tmpSecretId,
      tmpSecretKey,
      sessionToken,
      cdnUrl,
      key,
      startTime,
      expiredTime,
      region,
      bucket,
    };
  },
  bucket: config.bucket,
  region: config.region,
});

export default Cos;
